"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
function useDetectDimension(breakpoint) {
    if (breakpoint === void 0) { breakpoint = 768; }
    var detectDimension = react_1.default.useCallback(function () {
        if (typeof window !== 'undefined') {
            var nextDimension = {
                rwd: 'mobile',
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
            };
            if (window.innerWidth > breakpoint) {
                nextDimension.rwd = 'desktop';
            }
            reconnect_js_1.getOutlet('dimension').update(nextDimension);
        }
    }, [breakpoint]);
    var onResize = react_1.default.useCallback(function () {
        detectDimension();
    }, [detectDimension]);
    react_1.default.useEffect(function () {
        try {
            detectDimension();
            if (typeof window !== 'undefined') {
                window.addEventListener('resize', onResize);
            }
            return function () {
                if (typeof window !== undefined) {
                    window.removeEventListener('resize', onResize);
                }
            };
        }
        catch (ex) {
            console.warn('Provider:useEffect', ex);
        }
    }, [onResize, detectDimension]);
}
exports.default = useDetectDimension;
